<template>
    <v-sheet color="bgtopology" class="defaultCard">
        <v-speed-dial
        location="top center"
        transition="slide-x-transition"
        :close-on-content-click="false"
        >
        <template v-slot:activator="{ props: activatorProps }">
            <v-row class="ma-2" justify="start">
                <v-btn color="bgDashCard" size="small" class="mr-4"  v-bind="activatorProps"> Selecciona Fecha </v-btn>
                <h4  style="width: max-content !important;"> Se eliminaran datos anteriores a: {{ timeSelected }}</h4>
            </v-row>
        </template>

        
        <v-date-picker 
        key="1" 
        color="primary"
        :max="dateMax"
        v-model="datePickVal"
        @update:model-value="changeDate(datePickVal)"
        show-adjacent-months
        ></v-date-picker>

        </v-speed-dial>

        <v-row class="ma-0">
            <v-col cols="6" sm="6" md="4" lg="3" xl="2" xxl="2">
                <v-checkbox
                v-model="dbSelected"
                label="Cambium Data"
                value="cambium_data"
                :color="color['cambium_data']"
                :readonly="color['cambium_data'] === 'green'"
                ></v-checkbox>
            </v-col>
            <v-col cols="6" sm="6" md="4" lg="3" xl="2" xxl="2">
                <v-checkbox
                v-model="dbSelected"
                label="eventos"
                value="eventos"
                :color="color['eventos']"
                :readonly="color['eventos'] === 'green'"
                ></v-checkbox>
            </v-col>
            <v-col cols="6" sm="6" md="4" lg="3" xl="2" xxl="2">
                <v-checkbox
                v-model="dbSelected"
                label="latencia"
                value="latencia"
                :color="color['latencia']"
                :readonly="color['latencia'] === 'green'"
                ></v-checkbox>
            </v-col>
            <v-col cols="6" sm="6" md="4" lg="3" xl="2" xxl="2">
                <v-checkbox
                v-model="dbSelected"
                label="LTE Data"
                value="LTE_data"
                :color="color['LTE_data']"
                :readonly="color['LTE_data'] === 'green'"
                ></v-checkbox>
            </v-col>
            <v-col cols="6" sm="6" md="4" lg="3" xl="2" xxl="2">
                <v-checkbox
                v-model="dbSelected"
                label="predicciones"
                value="predicciones"
                :color="color['predicciones']"
                :readonly="color['predicciones'] === 'green'"
                ></v-checkbox>
            </v-col>
            <v-col cols="6" sm="6" md="4" lg="3" xl="2" xxl="2">
                <v-checkbox
                v-model="dbSelected"
                label="Rajant Data"
                value="rajant_data"
                :color="color['rajant_data']"
                :readonly="color['rajant_data'] === 'green'"
                ></v-checkbox>
            </v-col>
            <v-col cols="6" sm="6" md="4" lg="3" xl="2" xxl="2">
                <v-checkbox
                v-model="dbSelected"
                label="sensores"
                value="sensores"
                :color="color['sensores']"
                :readonly="color['sensores'] === 'green'"
                ></v-checkbox>
            </v-col>
            <v-col cols="6" sm="6" md="4" lg="3" xl="2" xxl="2">
                <v-checkbox
                v-model="dbSelected"
                label="Servidor Data"
                value="servidor_data"
                :color="color['servidor_data']"
                :readonly="color['servidor_data'] === 'green'"
                ></v-checkbox>
            </v-col>
            <v-col cols="6" sm="6" md="4" lg="3" xl="2" xxl="2">
                <v-checkbox
                v-model="dbSelected"
                label="Ubicación GPS"
                value="ubicacion_gps"
                :color="color['ubicacion_gps']"
                :readonly="color['ubicacion_gps'] === 'green'"
                ></v-checkbox>
            </v-col>
        </v-row>
        
        <v-btn color="btnSelect" @click="CleanDB()" class="mt-5" :disabled="!(dbSelected.length > 0)"> limpiar </v-btn>
    </v-sheet>
</template>

<script setup lang="ts">
import { ref, Ref, onMounted } from 'vue';
import { useStore }     from 'vuex';
import axios            from 'axios';

// CONSTANTS
import CONSTAPIS        from '@/constants/apis';

// INTERFACES
import { STRINGS }      from '@/interfaces/SmartLink/General';
import { TOKEN } from '@/constants/labels';

const store             = useStore();

const color:Ref<STRINGS>         = ref({
    cambium_data        : 'red',
    eventos             : 'red',
    latencia            : 'red',
    LTE_data            : 'red',
    predicciones        : 'red',
    rajant_data         : 'red',
    sensores            : 'red',
    servidor_data       : 'red',
    ubicacion_gps       : 'red',
});

/**
 * Array con todas las tablas seleccionadas para eliminar los datos
 * anteriores al datePickVal. Es usada en los checkboxes
 */
const dbSelected        = ref([]);

/**
 * Valor maximo del datepicker, inicializa en el primer día del mes anterior.
 * Ese valor se realiza luego del "OnMounted" -> "getMaxDate()"
 */
const dateMax           = ref('');

/**
 * Valor de la fecha seleccionada del datepicker, por defecto es el "dateMax"
 */
const datePickVal       = ref(new Date());

/**
 * Valor del tiempo seleccionado, para el título.
 */
const timeSelected      = ref('');


/**
 * Captura una fecha y regresa el formato final para la DB
 * @param date 
 */
const changeDate = async (date:Date) => {
    let getFinalDay      = date.getDate().toString().length === 1 ? `0${date.getDate()}` : `${date.getDate()}` ;
    let getFinalMonth    = (date.getMonth() + 1).toString().length === 1 ? `0${date.getMonth() + 1}` : `${date.getMonth() + 1}`;
    let getFinalYear     = date.getFullYear();
    
    timeSelected.value = `${getFinalYear}-${getFinalMonth}-${getFinalDay} 00:00:00`
}


/**
 * Captura el primer dia del mes anterior.
 * EJM: 
 *  NOW() : 03/04/2025
 *  DATE(): 01/03/2025
 */
const getMaxDate = async() => {
    let dateNow         = new Date();
    
    let getPrevMonth    = dateNow.getMonth() === 0 ? `12` : `${dateNow.getMonth()}`;
    let getFinalMonth   = getPrevMonth.length === 1 ? `0${getPrevMonth}` : `${getPrevMonth}`;
    let getFinalYear    = dateNow.getMonth() === 0 ? dateNow.getFullYear() - 1 : dateNow.getFullYear();
    
    dateMax.value       = `${getFinalYear}-${getFinalMonth}-01 00:00:00`;
    datePickVal.value   = new Date(dateMax.value)
}

/**
 * Realiza la eliminación de las tablas seleccionadas.
 */
const CleanDB = () => {

    /**
     * Del array de tablas seleccionadas, cada una envía una petición de eliminación
     */
    dbSelected.value.forEach((dbSel:string) => {

        let param = {
            table   : dbSel,
            time    : timeSelected.value, 
        }

        axios.delete(CONSTAPIS.APIS.value.general.deleteDataInDB,{params:param, headers: { "Authorization": `Bearer ${TOKEN}`}}).then((result) =>{
            if(!result.data.error){
                let database            = result.data.body;
                color.value[database]   = 'green';
                store.dispatch('showSnackBar', {type: 'setSnackDelete', msg: `datos eliminados`});
            }
        })
    })
}

onMounted(async ()=>{
    await getMaxDate();
    await changeDate(new Date(dateMax.value));
})

</script>